export default {"src":"/_next/static/media/home-safety.28cc1b95.svg","height":149,"width":200,"blurWidth":0,"blurHeight":0};